var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-arrow calendar-arrow-input" }, [
    _c("div", { staticClass: "input-month" }, [
      _c(
        "button",
        {
          ref: "prevBtn",
          attrs: { disabled: !_vm.hasPrevMonth },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.prevMonth($event)
            },
          },
        },
        [
          _c("i", {
            staticClass: "icon-chevron-left",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "month-name" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.tc("calendar.months." + _vm.currentMonthIndex)) +
            " " +
            _vm._s(_vm.currentYear) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          ref: "nextBtn",
          attrs: { disabled: !_vm.hasNextMonth },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.nextMonth($event)
            },
          },
        },
        [
          _c("i", {
            staticClass: "icon-chevron-right",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar-arrow-header-days" },
      _vm._l([7, 1, 2, 3, 4, 5, 6], function (week) {
        return _c("span", { key: week, staticClass: "week-short" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.tc("calendar.daysMobile." + week)) +
              "\n    "
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "month-wrapper" },
      [
        _c(
          "transition",
          { attrs: { name: "gallery-slide-" + _vm.transitionDirection } },
          [
            _c("range-calendar-month", {
              key: _vm.currentMonth,
              attrs: {
                month: _vm.currentMonth,
                "selected-start-date": _vm.selectedStartDate,
                "selected-end-date": _vm.selectedEndDate,
                "available-dates": _vm.availableDates,
                "input-selected": _vm.inputSelected,
                "current-focus": _vm.currentFocus,
              },
              on: { "refresh-focusable": _vm.changeFocusable },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "input-cta" }, [
      _vm.showResetButton
        ? _c(
            "button",
            {
              staticClass: "reset-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.resetCalendarDates($event)
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.tc("calendar.resetLabel")) + "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.handleClickButton($event)
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.tc("calendar.doneLabel")) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }